export default ({ request }) => ({
  changeOrdeDemandPackageListApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/package/list',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackageDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/package/detail',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackageAddApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/package/add',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackageModifyApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/package/modify',
      method: 'post',
      data
    })
  },
  changeOrdeDemandPackageBatchDelApi(data = {}) {
    return request({
      url: '/factory/change/order/demand/package/batchDel',
      method: 'post',
      data
    })
  }
})
